/* External */
import PropTypes from 'prop-types';

/* Ott-common */
import { Errors } from '@dtvgo/player-utils';

/* Components */
import ErrorScreen from '~/components/ErrorScreen';
import UpSellMessage from '~/components/UpSellMessage';

/* Other */
import { IS_UPSELL_MESSAGES_ACTIVE } from '~/utils/env';

export default function PlayerMessage({
  content = undefined,
  error,
  contentTitle = '',
  channelId = '',
  exit,
  isFromInterstitial = false,
  isCurrentInterstitialSchedule = false,
}) {
  const isErrorNIPGooglePlay = error.data?.response?.data?.details
    === Errors.AuthorizerErrorCode.GOOGLE_PLAY_NOT_IN_PACKAGE;
  const isErrorNotInPackage = error.category === Errors.ErrorCategory.NOT_IN_PACKAGE;

  const showUpSellMessage = IS_UPSELL_MESSAGES_ACTIVE
    && !isErrorNIPGooglePlay && isErrorNotInPackage;

  return showUpSellMessage
    ? (
      <UpSellMessage
        content={content}
        error={error}
        contentTitle={contentTitle}
        channelId={channelId}
        exit={exit}
      />
    )
    : (
      <ErrorScreen
        error={error}
        contentTitle={contentTitle}
        exit={exit}
        isFromInterstitial={isFromInterstitial}
        isCurrentInterstitialSchedule={isCurrentInterstitialSchedule}
      />
    );
}

PlayerMessage.propTypes = {
  content: PropTypes.shape({}),
  error: PropTypes.shape({
    category: PropTypes.string.isRequired,
    data: PropTypes.shape({
      response: PropTypes.shape({
        data: PropTypes.shape({
          details: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
  contentTitle: PropTypes.string,
  channelId: PropTypes.string,
  exit: PropTypes.func.isRequired,
  isFromInterstitial: PropTypes.bool,
  isCurrentInterstitialSchedule: PropTypes.bool,
};
